import { useEffect, useState } from 'react';

/** Renders page 1 of a PDF as a sharp image (the media kit can only show pictures, not PDFs). */
export function PdfPageImage({ url, alt, className = '' }: { url: string; alt: string; className?: string }) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const pdfjs = await import('pdfjs-dist');
        pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
        const doc = await pdfjs.getDocument(url).promise;
        const page = await doc.getPage(1);
        const viewport = page.getViewport({ scale: 2.5 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width; canvas.height = viewport.height;
        await page.render({ canvas, viewport }).promise;
        if (active) setSrc(canvas.toDataURL('image/jpeg', 0.92));
      } catch (e) {
        console.error(e);
        if (active) setFailed(true);
      }
    })();
    return () => { active = false; };
  }, [url]);
  if (src) return <img src={src} alt={alt} className={className} />;
  return <div className="flex h-full w-full items-center justify-center text-xs uppercase tracking-widest opacity-60">{failed ? 'Cover could not load' : 'Loading cover…'}</div>;
}
